import React, { useEffect, useState } from "react"

import arrow from "../../assets/images/next_arrow.svg"
import styles from "./Stepper.module.scss"

type StepProps = {
    number: number
    onChangeHandler: (active: number) => void
    active: boolean
    step: string
    total: number
    activeIndex: number
    allowed?: number[]
}
const Step = ({ number, onChangeHandler, active, step, total, activeIndex, allowed = [] }: StepProps) => {
    return (
        <div className={styles.step}>
            <div
                className={`${styles.step_container} ${active ? styles.step_active : ""}`}
                style={{ cursor: allowed?.length && allowed?.includes(number) ? "pointer" : "not-allowed" }}
                onClick={() => {
                    if (allowed?.length && allowed?.includes(number)) onChangeHandler(number)
                }}
            >
                {number}
            </div>
            {active && <div className={styles.step_title}>{step}</div>}
            {total > 1 && number < total && <img src={arrow} alt="arrow" />}
        </div>
    )
}

type StepperProps = {
    steps: string[]
    onChange: (active: number) => void
    allowed?: number[]
    activeFromParent?: number
}
const Stepper = (props: StepperProps) => {
    const { steps, onChange, allowed, activeFromParent } = props
    const [active, setActive] = useState(activeFromParent || 1)

    const onChangeHandler = (active: number) => {
        setActive(active)
        onChange(active)
    }

    useEffect(() => {
        if (activeFromParent) setActive(activeFromParent)
    }, [activeFromParent])

    return (
        <div className={styles.stepper_container}>
            {steps?.map((step, index) => {
                return (
                    <Step
                        allowed={allowed}
                        key={index}
                        number={index + 1}
                        onChangeHandler={onChangeHandler}
                        activeIndex={active}
                        active={active === index + 1}
                        step={step}
                        total={steps.length}
                    />
                )
            })}
        </div>
    )
}

export default Stepper
